import { render, staticRenderFns } from "./OtherFiles.vue?vue&type=template&id=6fe082f0&scoped=true"
import script from "./OtherFiles.vue?vue&type=script&lang=js"
export * from "./OtherFiles.vue?vue&type=script&lang=js"
import style0 from "./OtherFiles.vue?vue&type=style&index=0&id=6fe082f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe082f0",
  null
  
)

export default component.exports